'use strict';

// Globals and dependenaccordioncies
/* global Vue */
/* global loadjs */

loadjs.ready(['vue'], {
  success: function success() {
    // Define a new component called accordion-item
    Vue.component('accordion-item', {
      props: ['item', 'isOpen'],
      methods: {
        toggle: function toggle() {
          this.$emit('toggled', this.$vnode.key);
        }
      },
      template: '\n        <div>\n          <div class="accordion-heading-wrapper">\n            <button\n              class="icon-plus"\n              @click.prevent="toggle"\n            >\n              <svg v-if="isOpen" width="25" height="25" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 52 52" style="enable-background:new 0 0 52 52;" xml:space="preserve">\n                <g>\n                  <path d="M26,0C11.664,0,0,11.663,0,26s11.664,26,26,26s26-11.663,26-26S40.336,0,26,0z M26,50C12.767,50,2,39.233,2,26   S12.767,2,26,2s24,10.767,24,24S39.233,50,26,50z"/>\n                  <path d="M35.707,16.293c-0.391-0.391-1.023-0.391-1.414,0L26,24.586l-8.293-8.293c-0.391-0.391-1.023-0.391-1.414,0   s-0.391,1.023,0,1.414L24.586,26l-8.293,8.293c-0.391,0.391-0.391,1.023,0,1.414C16.488,35.902,16.744,36,17,36   s0.512-0.098,0.707-0.293L26,27.414l8.293,8.293C34.488,35.902,34.744,36,35,36s0.512-0.098,0.707-0.293   c0.391-0.391,0.391-1.023,0-1.414L27.414,26l8.293-8.293C36.098,17.316,36.098,16.684,35.707,16.293z"/>\n                </g>\n              </svg>\n\n              <svg v-else width="25" height="25" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 52 52" style="enable-background:new 0 0 52 52;" xml:space="preserve">\n                <g>\n                  <path d="M26,0C11.664,0,0,11.663,0,26s11.664,26,26,26s26-11.663,26-26S40.336,0,26,0z M26,50C12.767,50,2,39.233,2,26   S12.767,2,26,2s24,10.767,24,24S39.233,50,26,50z"/>\n                  <path d="M38.5,25H27V14c0-0.553-0.448-1-1-1s-1,0.447-1,1v11H13.5c-0.552,0-1,0.447-1,1s0.448,1,1,1H25v12c0,0.553,0.448,1,1,1   s1-0.447,1-1V27h11.5c0.552,0,1-0.447,1-1S39.052,25,38.5,25z"/>\n                </g>\n              </svg>\n            </button>\n\n            <h3\n              class="accordion-heading"\n              v-html="item.heading"\n              @click.prevent="toggle"\n            ></h3>\n          </div>\n\n          <div class="accordion-text" v-html="item.text" v-show="isOpen"></div>\n        </div>\n      '
    });

    // Define a new component called accordion
    Vue.component('accordion', {
      props: ['heading', 'text', 'items'],
      data: function data() {
        return { activeItemIndex: null };
      },
      methods: {
        onToggle: function onToggle(index) {
          if (this.activeItemIndex === index) {
            this.activeItemIndex = null;

            return;
          }

          this.activeItemIndex = index;

          var topPos = document.querySelectorAll('.accordion-heading')[index].getBoundingClientRect().top + window.scrollY;

          window.scrollTo({
            top: topPos - 55,
            behavior: 'smooth'
          });
        }
      },
      template: '\n        <div class="accordion-component">\n\n          <h2 class="accordion-intro-heading" v-html="heading"></h2>\n          <p class="accordion-intro-text" v-html="text"></p>\n\n          <accordion-item\n            v-for="(item, index) in items"\n            :item="item"\n            :key="index"\n            :isOpen="activeItemIndex == index"\n            @toggled="onToggle"\n          ></accordion-item>\n        </div>\n      '
    });
  }
});